<template>
  <div class="grid-view">
    <div class="main-content">
      <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search">
        <el-form
          label-position="middle"
          label-width="80px"
        >
          <div class="el-form-item-wrapper" style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_InstructionChineseName')">
              <el-input v-model="filter.chineseName" :placeholder="$t('SeaExport.PleaseInputAKeyword')" style="width: 300px" />
            </el-form-item>
            <div style="padding-left: 10px">
              <el-button no="3" type="primary" @click="filter.pageNum=1;queryHandler()">
                {{ $t('CargoMsg.Cargo_Query') }}
              </el-button>
              <el-button no="4" type="primary" @click="addHandler">
                {{ $t('CargoMsg.Cargo_Add') }}
              </el-button>
              <el-button no="5" type="primary" @click="editHandler">
                {{ $t('CargoMsg.Cargo_Edit') }}
              </el-button>
              <el-button no="6" type="danger" @click="deleteHandler">
                {{ $t('CargoMsg.Cargo_OrderDelete') }}
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
      <!--  业务层级的 表格 显示通用的字段  -->
      <div v-if="dataType === INSTRUCTION_TREE_DATE_TYPE_LOB.code" style="display: flex;flex-direction: column;flex-grow: 1">
        <div class="app-main-inner-row" style="flex-grow: 1;min-height: 400px">
          <cargo-ag-grid
            no="grid"
            config-module="1014252"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="girdParams"
            :grid-options="gridOptions"
          />
        </div>
        <div class="app-main-inner-row row-pagination">
          <cargo-pagination
            no="pagination"
            config-module="1014252"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="queryHandler"
          />
        </div>
      </div>
      <!--  指令类型层级的 表格 显示通用的 + 指定类型特有的字段 todo  -->
    </div>
    <!--  新增编辑弹框  -->
    <el-dialog
      v-if="settingDialog.visible"
      ref="settingDialog"
      v-el-drag-dialog
      :visible.sync="settingDialog.visible"
      :title="settingDialog.title"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="130px" label-position="right">
          <!--  指令基本配置  -->
          <el-form-item :label="$t('CargoMsg.Cargo_InstructionType')" label-width="130px">
            <cargo-advance-select
              :clearable="false"
              no="instructionType"
              tag-value="code"
              filterable
              style="width: 390px"
              :default-value="settingDialog.form.instructionType"
              :static-options="INSTRUCTION_TYPES"
              @parentCallBack="instructionTypeChange"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_InstructionCode')">
            <el-input v-model="settingDialog.form.instructionCode" no="instructionCode" style="width: 390px;" @blur="() => settingDialog.form.instructionCode = settingDialog.form.instructionCode.trim()" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CommandDisplayName')">
            <el-radio-group v-model="settingDialog.instructionDisplayName" no="instructionDisplayName" style="margin-bottom: 5px;">
              <el-radio-button :label="ZH_CN.code">{{ $t('Tool.Chinese') }}</el-radio-button>
              <el-radio-button :label="EN_US.code">{{ $t('Tool.English') }}</el-radio-button>
              <el-radio-button :label="JA_JP.code">{{ $t('Tool.Japanese') }}</el-radio-button>
            </el-radio-group>
            <div style="width: 390px">
              <el-input v-if="settingDialog.instructionDisplayName === ZH_CN.code" v-model="settingDialog.form.chineseName" no="chineseName" @blur="() => settingDialog.form.chineseName = settingDialog.form.chineseName.trim()" />
              <el-input v-if="settingDialog.instructionDisplayName === EN_US.code" v-model="settingDialog.form.englishName" no="englishName" @blur="() => settingDialog.form.englishName = settingDialog.form.englishName.trim()" />
              <el-input v-if="settingDialog.instructionDisplayName === JA_JP.code" v-model="settingDialog.form.japaneseName" no="japaneseName" @blur="() => settingDialog.form.japaneseName = settingDialog.form.japaneseName.trim()" />
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_InstructionDescription')">
            <el-input v-model="settingDialog.form.instructionDescription" no="instructionDescription" type="textarea" :rows="3" style="width: 390px;" @blur="() => settingDialog.form.instructionDescription = settingDialog.form.instructionDescription.trim()" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SelectOperationInstruction')">
            <!--  选择 平台操作指令弹窗  -->
            <platform-instruction-dialog
              width="600px"
              :lob="lob"
              :platform-instruction-uuid="settingDialog.form.platformInstructionUuid"
              :platform-instructions="platformInstructions"
              :instruction-type="settingDialog.form.instructionType"
              @change="platformInstructionChange"
            />
          </el-form-item>

          <!--  指令类型专属配置  -->
          <!--  发送邮件 指令  -->
          <div v-if="settingDialog.form.instructionType === INSTRUCTION_TYPE_SEND_EMAIL.code">
            <el-divider />
            <div style="font-size:12px; margin-bottom: 5px;">{{ $t('CargoMsg.Cargo_InstructionRuleSetting') }}</div>
            <el-form-item :label="$t('CargoMsg.Cargo_IfAllowedSendMultipleTimes')">
              <el-radio-group v-model="settingDialog.form.allowMultipleOperations" no="allowMultipleOperations">
                <el-radio :label="false">{{ $t('CargoMsg.Cargo_CanOnlyBeSentOnce') }}</el-radio>
                <el-radio :label="true">{{ $t('CargoMsg.Cargo_CanBeSentMultipleTimes') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TemplateMatching')">
              <el-checkbox v-model="settingDialog.form.instructionRuleJson.selectPushLink" no="matchOfficeTemplate" style="width: 390px;" maxlength="20" @change="selectPushLinkChange">
                {{ $t('CargoMsg.Cargo_UnifiedBusinessScenario') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item :label="getMailboxManagementDialogTitle()">
              <!--选择邮件模板 or 推送环节弹窗-->
              <mailbox-management-dialog
                width="600px"
                :lob="lob"
                :mail-template-uuid="settingDialog.form.instructionRuleJson.mailTemplateUuid"
                :push-link="settingDialog.form.instructionRuleJson.pushLink"
                :mail-templates="mailTemplates"
                :select-push-link="settingDialog.form.instructionRuleJson.selectPushLink"
                @change="emailTemplateChange"
              />
            </el-form-item>
          </div>
          <!--  上传文件 指令  -->
          <div v-if="settingDialog.form.instructionType === INSTRUCTION_TYPE_UPLOAD_FILE.code">
            <el-divider />
            <div style="font-size:12px; margin-bottom: 5px;">{{ $t('CargoMsg.Cargo_InstructionRuleSetting') }}</div>
            <el-form-item :label="$t('CargoMsg.Cargo_SetUploadFileType')">
              <el-select v-model="settingDialog.form.instructionRuleJson.fileCategoryLabel" no="fileCategoryLabel" style="width: 390px" @click.native="fileTypeEditor.visible = true">
                <el-option
                  v-for="(item,index) in [settingDialog.form.instructionRuleJson.fileCategoryLabel]"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </div>
          <!--  打印文件 指令  -->
          <div v-if="settingDialog.form.instructionType === INSTRUCTION_TYPE_PRINT_FILE.code">
            <el-divider />
            <div style="font-size:12px; margin-bottom: 5px;">{{ $t('CargoMsg.Cargo_InstructionRuleSetting') }}</div>
            <el-form-item :label="$t('CargoMsg.Cargo_IfAllowedSendMultipleTimes')">
              <el-radio-group v-model="settingDialog.form.allowMultipleOperations" no="allowMultipleOperations2">
                <el-radio :label="false">{{ $t('CargoMsg.Cargo_CanOnlyPrintOnce') }}</el-radio>
                <el-radio :label="true">{{ $t('CargoMsg.Cargo_CanPrintMultipleTimes') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TemplateMatching')">
              <el-checkbox v-model="settingDialog.form.instructionRuleJson.selectFileType" no="selectFileType" style="width: 390px;" maxlength="20" @change="selectFileTypeChange">
                {{ $t('CargoMsg.Cargo_IfSelectTemplateType') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PrintMode')">
              <div style="display: flex;width: 200px">
                <el-checkbox v-model="settingDialog.form.instructionRuleJson.singleJobPrint" no="singleJobPrint" style="width: 390px;" maxlength="20" @change="singleJobPrintChange">
                  {{ $t('CargoMsg.Cargo_SingleJobPrint') }}
                </el-checkbox>
                <el-checkbox v-model="settingDialog.form.instructionRuleJson.batchJobPrint" no="batchJobPrint" style="width: 390px;" maxlength="20" @change="batchJobPrintChange">
                  {{ $t('CargoMsg.Cargo_BatchJobPrint') }}
                </el-checkbox>
              </div>
            </el-form-item>
            <el-form-item v-if="settingDialog.form.instructionRuleJson.singleJobPrint" :label="getTemplateManagementDialogTitle()">
              <!--选择 单个业务的打印模板 or 打印模板的文件类型弹窗-->
              <template-management-dialog
                width="600px"
                :lob="lob"
                :template-uuids="settingDialog.form.instructionRuleJson.templateUuids"
                :document-type-uuid="settingDialog.form.instructionRuleJson.documentTypeUuid"
                :templates="templates"
                :select-file-type="settingDialog.form.instructionRuleJson.selectFileType"
                @change="templateChange"
              />
            </el-form-item>
            <el-form-item v-if="settingDialog.form.instructionRuleJson.batchJobPrint" :label="getBatchTemplateManagementDialogTitle()">
              <!--选择 批量业务的打印模板 or 打印模板的文件类型弹窗-->
              <batch-template-management-dialog
                width="600px"
                :lob="lob"
                :batch-template-uuid="settingDialog.form.instructionRuleJson.batchTemplateUuid"
                :bach-document-type-uuid="settingDialog.form.instructionRuleJson.bachDocumentTypeUuid"
                :templates="templates"
                :select-file-type="settingDialog.form.instructionRuleJson.selectFileType"
                @change="batchTemplateChange"
              />
            </el-form-item>
          </div>
          <!--  跳转页面 指令  -->
          <div v-if="settingDialog.form.instructionType === INSTRUCTION_TYPE_JUMP_PAGE.code">
            <el-divider />
            <div style="font-size:12px; margin-bottom: 5px;">{{ $t('CargoMsg.Cargo_InstructionRuleSetting') }}</div>
            <el-form-item :label="$t('CargoMsg.Cargo_SelectJumpPage')">
              <el-select v-model="settingDialog.form.instructionRuleJson.jumpName" no="jumpPath" style="width: 390px" @click.native="treeEditor.visible = true">
                <el-option
                  v-for="(item,index) in [settingDialog.form.instructionRuleJson.jumpName]"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_JumpSet')">
              <el-checkbox v-model="settingDialog.form.instructionRuleJson.clickJobNoJumpPage" no="selectFileType" style="width: 390px;" maxlength="20" @change="selectFileTypeChange">
                {{ $t('CargoMsg.Cargo_ClickJobNoJumpPage') }}
              </el-checkbox>
            </el-form-item>
          </div>
          <!--  数据填写 指令  -->
          <div v-if="settingDialog.form.instructionType === INSTRUCTION_TYPE_DATA_FILL.code">
            <el-divider />
            <div style="font-size:12px; margin-bottom: 5px;">{{ $t('CargoMsg.Cargo_InstructionRuleSetting') }}</div>
            <el-form-item :label="$t('CargoMsg.Cargo_IfAllowedSendMultipleTimes')">
              <el-radio-group v-model="settingDialog.form.allowMultipleOperations" no="allowMultipleOperations">
                <el-radio :label="false">{{ $t('CargoMsg.Cargo_CanOnlyBeSentOnce') }}</el-radio>
                <el-radio :label="true">{{ $t('CargoMsg.Cargo_CanBeSentMultipleTimes') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.FillInMode')">
              <el-checkbox v-model="settingDialog.form.instructionRuleJson.singleTicketBusinessEntry" @change="singleTicketBusinessEntryChange">
                {{ $t('SystemMaintenance.SingleTicketBusinessForm') }}
              </el-checkbox>
              <el-checkbox v-model="settingDialog.form.instructionRuleJson.batchBusinessProcessing" @change="batchBusinessProcessingChange">
                {{ $t('SystemMaintenance.BulkProcessing') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.SingleFormSubmission')">
              <custom-form-select-dialog
                width="600px"
                :lob="lob"
                :form-uuid="settingDialog.form.instructionRuleJson.singleFormUuid"
                :form-name="settingDialog.form.instructionRuleJson.singleFormName"
                :form-list="uiCustomForms"
                :application-scene="APPLICATION_SCENE.BUSINESS_SINGLE.value"
                :disabled="!settingDialog.form.instructionRuleJson.singleTicketBusinessEntry"
                @change="data => {
                  if (settingDialog.form.instructionRuleJson.singleTicketBusinessEntry) {
                    settingDialog.form.instructionRuleJson.singleFormUuid = data.uuid,
                    settingDialog.form.instructionRuleJson.singleFormName = data.name
                  }
                }"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.BatchFillOutForms')">
              <div style="display: flex; align-items: center;">
                <custom-form-select-dialog
                  width="600px"
                  :lob="lob"
                  :form-uuid="settingDialog.form.instructionRuleJson.batchFormUuid"
                  :form-name="settingDialog.form.instructionRuleJson.batchFormName"
                  :form-list="uiCustomForms"
                  :application-scene="APPLICATION_SCENE.BUSINESS_BATCH.value"
                  :disabled="!settingDialog.form.instructionRuleJson.batchBusinessProcessing"
                  @change="data => {
                    if (settingDialog.form.instructionRuleJson.batchBusinessProcessing) {
                      settingDialog.form.instructionRuleJson.batchFormUuid = data.uuid,
                      settingDialog.form.instructionRuleJson.batchFormName = data.name
                    }
                  }"
                />
                <el-checkbox
                  v-model="settingDialog.form.instructionRuleJson.batchModificationPrompt"
                  style="margin-left: 10px;"
                  :disabled="!settingDialog.form.instructionRuleJson.batchBusinessProcessing"
                >
                  {{ $t('SystemMaintenance.BatchModificationPrompt') }}
                </el-checkbox>
              </div>
            </el-form-item>
          </div>
          <!--  其他操作 指令  -->
          <div v-if="settingDialog.form.instructionType === INSTRUCTION_TYPE_OTHER_OPERATION.code">
            <el-divider />
            <div style="font-size:12px; margin-bottom: 5px;">{{ $t('CargoMsg.Cargo_InstructionRuleSetting') }}</div>
            <el-form-item :label="$t('CargoMsg.Cargo_IfAllowedSendMultipleTimes')">
              <el-radio-group v-model="settingDialog.form.allowMultipleOperations" no="allowMultipleOperations">
                <el-radio :label="false">{{ $t('CargoMsg.Cargo_CanOnlyBeSentOnce') }}</el-radio>
                <el-radio :label="true">{{ $t('CargoMsg.Cargo_CanBeSentMultipleTimes') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.BatchOperationSettings')">
              <el-checkbox v-model="settingDialog.form.instructionRuleJson.batchOperate" @change="batchOperateChange">
                {{ $t('SystemMaintenance.BatchOperationsSupported') }}
              </el-checkbox>
              <el-checkbox v-model="settingDialog.form.instructionRuleJson.batchOperateTip" :disabled="!settingDialog.form.instructionRuleJson.batchOperate">
                {{ $t('SystemMaintenance.BulkOperationPrompt') }}
              </el-checkbox>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="13" type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button no="14" @click="settingDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="lob"
      file-id=""
      :file-category="settingDialog.form.instructionRuleJson.fileCategory || ''"
      :row-selection="ROW_SELECTION_SINGLE.code"
      @saveFileType="saveFileTypeHandle"
    />
    <!-- 跳转页面对话框 -->
    <tree-editor
      v-if="treeEditor.visible"
      :visible.sync="treeEditor.visible"
      :path="settingDialog.form.instructionRuleJson.jumpPath || ''"
      :append-to-body="true"
      :row-selection="ROW_SELECTION_SINGLE.code"
      :title="$t('CargoMsg.Cargo_SelectJumpPage')"
      :row-data="jumpTree"
      @callback="saveJumpPath"
    />
  </div>
</template>
<script>
import ColumnUtils from '@/utils/ColumnUtils'
import {
  BB_SEND_DESTINATIOIN_PORT_AGENT,
  EMAIL_PARSING_TYPE,
  INSTRUCTION_SOURCES,
  INSTRUCTION_TREE_DATE_TYPE_LOB, INSTRUCTION_TYPE_JUMP_PAGE,
  INSTRUCTION_TYPE_PRINT_FILE,
  INSTRUCTION_TYPE_SEND_EMAIL,
  INSTRUCTION_TYPE_OTHER_OPERATION,
  INSTRUCTION_TYPE_UPLOAD_FILE,
  INSTRUCTION_TYPE_DATA_FILL,
  INSTRUCTION_TYPES,
  ROW_SELECTION_SINGLE,
  SE
} from '@/class/cargo/model/parameters/SystemConstants'
import { APPLICATION_SCENE } from '@/class/cargo/model/parameters/AiCustomPageConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { EN_US, JA_JP, ZH_CN } from '@/class/cargo/model/parameters/LanguageConstant'
import {
  deleteTenantInstruction,
  queryTenantInstruction,
  saveTenantInstruction
} from '@/api/sysManage/baseConfig/instruction'
import PlatformInstructionDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/platformInstructionDialog'
import MailboxManagementDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/mailboxManagementDialog'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import TemplateManagementDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/templateManagementDialog'
import BatchTemplateManagementDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/batchTemplateManagementDialog'
import { deepClone } from '@/utils'
import { JumpUtil } from '@/utils/JumpUtil'
import TreeEditor from '@/components/Cargo/Job/treeEditor'
import CustomFormSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/tenantInstruction/customFormSelectDialog'
import { queryFormsByCondition } from '@/api/sysManage/aiCustomPage'

export default {
  name: 'TenantInstruction',
  components: {
    PlatformInstructionDialog,
    CargoAdvanceSelect,
    MailboxManagementDialog,
    MxFileTypeEditor,
    TemplateManagementDialog,
    BatchTemplateManagementDialog,
    TreeEditor,
    CustomFormSelectDialog
  },
  props: {
    dataType: { type: String, default: INSTRUCTION_TREE_DATE_TYPE_LOB.code },
    instructionLob: { type: String, default: SE.code },
    instructionType: { type: String, default: '' },
    platformInstructions: { type: Array, default: () => [] }, // 平台 操作指令
    mailTemplates: { type: Array, default: () => [] }, // 邮件 模板列表
    templates: { type: Array, default: () => [] } // 打印 模板列表
  },
  data() {
    return {
      INSTRUCTION_TYPES, INSTRUCTION_SOURCES, INSTRUCTION_TREE_DATE_TYPE_LOB, INSTRUCTION_TYPE_SEND_EMAIL,
      INSTRUCTION_TYPE_OTHER_OPERATION,
      BB_SEND_DESTINATIOIN_PORT_AGENT,
      INSTRUCTION_TYPE_UPLOAD_FILE, ROW_SELECTION_SINGLE, INSTRUCTION_TYPE_PRINT_FILE, INSTRUCTION_TYPE_JUMP_PAGE,
      INSTRUCTION_TYPE_DATA_FILL,
      APPLICATION_SCENE,
      ZH_CN, EN_US, JA_JP,
      total: 0,
      isZh: this.$store.getters.language === 'zh',
      EMAIL_PARSING_TYPE,
      selectTypeNames: TYPE_NAMES,
      loading: false,
      selectedRow: null,
      tenants: [],
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          filter: true
        }
      },
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      settingDialog: {
        isEdit: false,
        title: this.$t('CargoMsg.Cargo_OperationInstructions'),
        visible: false,
        instructionDisplayName: ZH_CN.code,
        form: {
          uuid: '',
          version: 0,
          instructionType: INSTRUCTION_TYPE_SEND_EMAIL.code,
          instructionCode: '',
          chineseName: '',
          englishName: '',
          japaneseName: '',
          instructionDescription: '',
          allowMultipleOperations: false,
          instructionRule: {}, // 发送邮件：selectPushLink、mailTemplateUuid、pushLink 上传文件：fileCategory
          instructionRuleJson: {},
          platformInstructionUuid: '',
          lob: ''
        }
      },
      fileTypeEditor: {
        visible: false,
        fileId: ''
      },
      treeEditor: {
        visible: false
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionType'),
          field: 'instructionType',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.instructionTypeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionCode'),
          field: 'instructionCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionChineseName'),
          field: 'chineseName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionEnglishName'),
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionJapaneseName'),
          field: 'japaneseName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionDescription'),
          field: 'instructionDescription',
          width: 200
        }
      ],
      uiCustomForms: []
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    jumpTree() {
      return JumpUtil.getJumpTree(this.lob)
    },
    lob() {
      return this.instructionLob.replace('FBA_', '')
    }
  },
  mounted() {
    this.queryUiCustomForms()
    this.queryHandler()
  },
  methods: {
    async queryUiCustomForms() {
      const requestData = {
        enabled: 2,
        pageSize: 10000
      }
      const response = await queryFormsByCondition(requestData)
      this.uiCustomForms = response.data.list || []
    },
    queryHandler() {
      this.loading = getLoading4Cxt(this)
      this.filter.lob = this.instructionLob
      queryTenantInstruction(this.filter).then(res => {
        if (res.data) {
          if (this.gridApi) {
            this.gridApi.setRowData(res.data.list)
          } else {
            this.rowData = res.data.list
          }
          this.filter.pageNum = res.data.pageNum
          this.filter.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    addHandler() {
      this.settingDialog.form = {
        uuid: '',
        version: 0,
        instructionType: INSTRUCTION_TYPE_SEND_EMAIL.code,
        instructionCode: '',
        chineseName: '',
        englishName: '',
        japaneseName: '',
        instructionDescription: '',
        allowMultipleOperations: false,
        instructionRule: {},
        instructionRuleJson: {},
        platformInstructionUuid: '',
        lob: ''
      }
      this.settingDialog.instructionDisplayName = ZH_CN.code
      this.settingDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_OperationInstructions')
      this.settingDialog.isEdit = false
      this.settingDialog.visible = true
    },
    editHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length !== 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return
      }
      this.settingDialog.form = deepClone(rows[0])
      if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_JUMP_PAGE.code) {
        if (this.settingDialog.form.instructionRuleJson.jumpPath) {
          const jump = this.jumpTree.find(jump => jump.path === this.settingDialog.form.instructionRuleJson.jumpPath)
          if (jump) {
            this.settingDialog.form.instructionRuleJson.jumpName = jump.name
          }
        }
      }
      // if (this.settingDialog.form.instructionRule) {
      //   this.settingDialog.form.instructionRule = JSON.parse(this.settingDialog.form.instructionRule)
      // }
      // if (this.settingDialog.form.instructionRuleJson.fileCategory && this.settingDialog.fileTypeMap) {
      //   this.settingDialog.fileCategoryLabel = this.settingDialog.fileTypeMap.get(this.settingDialog.form.instructionRuleJson.fileCategory.toUpperCase())
      // }
      this.settingDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_OperationInstructions')
      this.settingDialog.isEdit = true
      this.settingDialog.visible = true
    },
    deleteHandler() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteConfigTip'), this.$t('Message.WarmReminder'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading4Cxt(this)
        const data = {
          keys: Array.from(selectedRows, p => p.uuid)
        }
        deleteTenantInstruction(data).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.queryHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    saveHandler() {
      this.settingDialog.form.instructionRule = this.settingDialog.form.instructionRuleJson
      const form = { ...this.settingDialog.form }
      form.lob = this.instructionLob
      if (!form.instructionType) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_InstructionType'))
        return
      }
      if (!form.instructionCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_InstructionCode'))
        return
      }
      if (!form.chineseName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_InstructionChineseName'))
        return
      }
      if (!form.platformInstructionUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_OperationInstructions'))
        return
      }
      if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_SEND_EMAIL.code) {
        if (this.settingDialog.form.instructionRuleJson.selectPushLink) {
          if (!this.settingDialog.form.instructionRuleJson.pushLink) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SystemMaintenance.PushingLink'))
            return
          }
        } else {
          if (!this.settingDialog.form.instructionRuleJson.mailTemplateUuid) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.EmailTemplate'))
            return
          }
        }
      }
      if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_UPLOAD_FILE.code) {
        if (!this.settingDialog.form.instructionRuleJson.fileCategory) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.FileType'))
          return
        }
      }
      if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_PRINT_FILE.code) {
        if (this.settingDialog.form.instructionRuleJson.selectFileType) {
          if (this.settingDialog.form.instructionRuleJson.singleJobPrint && !this.settingDialog.form.instructionRuleJson.documentTypeUuid) {
            this.$message.error(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_SinglePrintFileType'))
            return
          }
          if (this.settingDialog.form.instructionRuleJson.batchJobPrint && !this.settingDialog.form.instructionRuleJson.bachDocumentTypeUuid) {
            this.$message.error(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_BatchPrintFileType'))
            return
          }
        } else {
          if (this.settingDialog.form.instructionRuleJson.singleJobPrint && (!this.settingDialog.form.instructionRuleJson.templateUuids || this.settingDialog.form.instructionRuleJson.templateUuids.length === 0)) {
            this.$message.error(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_SinglePrintFileType'))
            return
          }
          if (this.settingDialog.form.instructionRuleJson.batchJobPrint && !this.settingDialog.form.instructionRuleJson.batchTemplateUuid) {
            this.$message.error(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_BatchPrintFileTemplate'))
            return
          }
        }
      }
      if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_JUMP_PAGE.code) {
        if (!this.settingDialog.form.instructionRuleJson.jumpPath) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_JumpPage'))
          return
        }
      }
      if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_DATA_FILL.code) {
        // 至少选择一种填写模式
        if (!this.settingDialog.form.instructionRuleJson.singleTicketBusinessEntry &&
            !this.settingDialog.form.instructionRuleJson.batchBusinessProcessing) {
          this.$message.warning(this.$t('SystemMaintenance.PleaseSelectFillModeAndForm'))
          return
        }

        // 如果选择了单票业务，必须选择对应表单
        if (this.settingDialog.form.instructionRuleJson.singleTicketBusinessEntry &&
            !this.settingDialog.form.instructionRuleJson.singleFormUuid) {
          this.$message.warning(this.$t('SystemMaintenance.FillFormCannotBeEmpty'))
          return
        }

        // 如果选择了批量处理，必须选择对应表单
        if (this.settingDialog.form.instructionRuleJson.batchBusinessProcessing &&
            !this.settingDialog.form.instructionRuleJson.batchFormUuid) {
          this.$message.warning(this.$t('SystemMaintenance.FillFormCannotBeEmpty'))
          return
        }
      }

      // 正常提交流程
      this.executeFormSubmit(form)
    },
    executeFormSubmit(form) {
      const loading = getLoading4Cxt(this.$refs.settingDialog)
      saveTenantInstruction(form).then(() => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.settingDialog.visible = false
        this.queryHandler()
      }).finally(() => {
        loading.close()
      })
    },
    // 选择 平台操作指令
    platformInstructionChange(data) {
      if (data) {
        this.settingDialog.form.platformInstructionUuid = data.uuid
      } else {
        this.settingDialog.form.platformInstructionUuid = ''
      }
    },
    // 选择 邮件模板
    emailTemplateChange(data) {
      if (data) {
        if (this.settingDialog.form.instructionRuleJson.selectPushLink) {
          this.settingDialog.form.instructionRuleJson.pushLink = data.pushLink
        } else {
          this.settingDialog.form.instructionRuleJson.mailTemplateUuid = data.uuid
        }
      } else {
        this.settingDialog.form.instructionRuleJson.mailTemplateUuid = null
        this.settingDialog.form.instructionRuleJson.pushLink = null
      }
    },
    templateChange(data) {
      if (data) {
        if (this.settingDialog.form.instructionRuleJson.selectFileType) {
          this.settingDialog.form.instructionRuleJson.documentTypeUuid = data.documentTypeUuid
          // if (!data.documentTypeUuid) {
          //   this.$message.error(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_SinglePrintFileType'))
          // }
        } else {
          this.settingDialog.form.instructionRuleJson.templateUuids = data.map(p => p.uuid)
        }
      } else {
        this.settingDialog.form.instructionRuleJson.templateUuids = null
        this.settingDialog.form.instructionRuleJson.documentTypeUuid = null
      }
    },
    batchTemplateChange(data) {
      if (data) {
        if (this.settingDialog.form.instructionRuleJson.selectFileType) {
          this.settingDialog.form.instructionRuleJson.bachDocumentTypeUuid = data.documentTypeUuid
          // if (!data.documentTypeUuid) {
          //   this.$message.error(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_BatchPrintFileType'))
          // }
        } else {
          this.settingDialog.form.instructionRuleJson.batchTemplateUuid = data.uuid
        }
      } else {
        this.settingDialog.form.instructionRuleJson.batchTemplateUuid = null
        this.settingDialog.form.instructionRuleJson.bachDocumentTypeUuid = null
      }
    },
    getMailboxManagementDialogTitle() {
      if (this.settingDialog.form.instructionRuleJson.selectPushLink) {
        return this.$t('CargoMsg.Cargo_SelectThePushLink')
      } else {
        return this.$t('CargoMsg.Cargo_SelectEmailTemplate')
      }
    },
    getTemplateManagementDialogTitle() {
      if (this.settingDialog.form.instructionRuleJson.selectFileType) {
        return this.$t('CargoMsg.Cargo_SinglePrintFileType')
      } else {
        return this.$t('CargoMsg.Cargo_SinglePrintFileTemplate')
      }
    },
    getBatchTemplateManagementDialogTitle() {
      if (this.settingDialog.form.instructionRuleJson.selectFileType) {
        return this.$t('CargoMsg.Cargo_BatchPrintFileType')
      } else {
        return this.$t('CargoMsg.Cargo_BatchPrintFileTemplate')
      }
    },
    selectPushLinkChange() {
      if (this.settingDialog.form.instructionRuleJson.selectPushLink) {
        this.settingDialog.form.instructionRuleJson.mailTemplateUuid = null
      } else {
        this.settingDialog.form.instructionRuleJson.pushLink = null
      }
    },
    selectFileTypeChange() {
      if (this.settingDialog.form.instructionRuleJson.selectFileType) {
        this.settingDialog.form.instructionRuleJson.templateUuids = null
        this.settingDialog.form.instructionRuleJson.batchTemplateUuid = null
      } else {
        this.settingDialog.form.instructionRuleJson.documentTypeUuid = null
        this.settingDialog.form.instructionRuleJson.bachDocumentTypeUuid = null
      }
    },
    instructionTypeChange(p) {
      this.settingDialog.form.instructionType = p.value
      this.settingDialog.form.platformInstructionUuid = ''
      if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_SEND_EMAIL.code) {
        this.settingDialog.form.allowMultipleOperations = false
        this.settingDialog.form.instructionRuleJson = {}
      } else if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_PRINT_FILE.code) {
        this.settingDialog.form.allowMultipleOperations = false
        this.settingDialog.form.instructionRuleJson = {
          singleJobPrint: true,
          batchJobPrint: false
        }
      } else if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_JUMP_PAGE.code) {
        this.settingDialog.form.allowMultipleOperations = true
        this.settingDialog.form.instructionRuleJson = {
          clickJobNoJumpPage: true
        }
      } else if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_OTHER_OPERATION.code) {
        this.settingDialog.form.allowMultipleOperations = false
        this.settingDialog.form.instructionRuleJson = {
          batchOperate: false,
          batchOperateTip: false
        }
      } else if (this.settingDialog.form.instructionType === INSTRUCTION_TYPE_DATA_FILL.code) {
        this.settingDialog.form.allowMultipleOperations = true
        this.settingDialog.form.instructionRuleJson = {
          singleTicketBusinessEntry: true,
          batchBusinessProcessing: false,
          singleFormUuid: '',
          singleFormName: '',
          batchFormUuid: '',
          batchFormName: '',
          batchModificationPrompt: false
        }
      } else {
        // 默认其他指令都是 true
        this.settingDialog.form.allowMultipleOperations = true
        this.settingDialog.form.instructionRuleJson = {}
      }
      this.$forceUpdate()
    },
    singleJobPrintChange() {
      this.settingDialog.form.instructionRuleJson.templateUuids = null
      this.settingDialog.form.instructionRuleJson.documentTypeUuid = null
    },
    batchJobPrintChange() {
      this.settingDialog.form.instructionRuleJson.batchTemplateUuid = null
      this.settingDialog.form.instructionRuleJson.bachDocumentTypeUuid = null
    },
    saveFileTypeHandle(data) {
      this.settingDialog.form.instructionRuleJson.fileCategory = data.fileCategory
      this.settingDialog.form.instructionRuleJson.fileCategoryLabel = data.fileCategoryLabel
    },
    saveJumpPath(data) {
      this.settingDialog.form.instructionRuleJson.jumpPath = data.path
      this.settingDialog.form.instructionRuleJson.jumpName = data.name
    },
    // 单票业务表单入口复选框change事件
    singleTicketBusinessEntryChange() {
      if (!this.settingDialog.form.instructionRuleJson.singleTicketBusinessEntry) {
        // 取消选中时清空相关数据
        this.settingDialog.form.instructionRuleJson.singleFormUuid = ''
        this.settingDialog.form.instructionRuleJson.singleFormName = ''
      }
      this.$forceUpdate()
    },
    // 批量业务处理复选框change事件
    batchBusinessProcessingChange() {
      if (!this.settingDialog.form.instructionRuleJson.batchBusinessProcessing) {
        // 取消选中时清空相关数据
        this.settingDialog.form.instructionRuleJson.batchFormUuid = ''
        this.settingDialog.form.instructionRuleJson.batchFormName = ''
        this.settingDialog.form.instructionRuleJson.batchModificationPrompt = false
      }
      this.$forceUpdate()
    },
    batchOperateChange() {
      if (!this.settingDialog.form.instructionRuleJson.batchOperate) {
        this.settingDialog.form.instructionRuleJson.batchOperateTip = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

#app /deep/ .el-form-item__label {
  text-align: right;
}

.lable-blue ::v-deep {
  .el-form-item__label {
    color: #1F75D5 !important;
  }
}

</style>
